import { ReactNode } from 'react';
import { Packages } from './Settings/OptionalSettings/Packages';
import { DeviceModels } from './Settings/OptionalSettings/DeviceModels';
import { CsvImportColumn } from '../../lib/csv';
import { FIPS } from './Settings/OptionalSettings/FIPS';
import { Transports } from './Settings/OptionalSettings/Transports';
import {
  buildCsvColumns,
  DeviceModelImport,
  FipsCodeImport,
  mapCsvDeviceModels,
  mapCsvPackages,
  mapFipsCodes,
  mapTransports,
  PackageImport,
  TransportImport,
} from './Settings/csvImports';
import { MediaFirst } from './Settings/OptionalSettings/MediaFirst';
import {
  LiveTv,
  Map,
  Settings,
  SettingsInputComponent,
  Subscriptions,
} from '@material-ui/icons';

export interface CreateOperatorSettingProps {
  values: CreateOperator;
}

export interface CreateOperatorSetting {
  icon?: ReactNode;
  canImport: boolean;
  onImport?(data: any[]): any[];
  component: ReactNode;
  key?: keyof CreateOperator;
  csvColumns?: CsvImportColumn[];
  name: string;
  order: number;
  canOverwrite: boolean;
  show?: boolean;
}

const optionalSettings = (
  args: CreateOperatorSettingProps
): CreateOperatorSetting[] => [
  {
    order: 1,
    canOverwrite: true,
    canImport: true,
    component: <Packages />,
    icon: <Subscriptions />,
    key: 'subscriberGroups',
    csvColumns: buildCsvColumns<PackageImport>([
      {
        name: 'name',
        type: 'string',
      },
      {
        name: 'description',
        type: 'string',
      },
      {
        name: 'type',
        options: ['BASE', 'ALC', 'PKG'],
        type: 'string',
      },
    ]),
    name: 'Packages',
    onImport: (data) => mapCsvPackages(data),
  },
  {
    order: 2,
    canOverwrite: true,
    canImport: true,
    component: <DeviceModels />,
    icon: <LiveTv />,
    key: 'deviceModels',
    csvColumns: buildCsvColumns<DeviceModelImport>([
      {
        name: 'name',
        type: 'string',
      },
      {
        name: 'clientVersion',
        type: 'string',
      },
      {
        name: 'canDVR',
        options: ['0', '1', 'TRUE', 'FALSE'],
        type: 'boolean',
      },
      {
        name: 'system',
        options: ['MR', 'MF'],
        type: 'string',
      },
    ]),
    name: 'Device Models',
    onImport: (data) => mapCsvDeviceModels(data),
  },
  {
    order: 3,
    canOverwrite: true,
    canImport: true,
    component: <FIPS />,
    icon: <Map />,
    key: 'fipsCodes',
    csvColumns: buildCsvColumns<FipsCodeImport>([
      {
        name: 'code',
        type: 'string',
      },
      {
        name: 'countyName',
        type: 'string',
      },
    ]),
    name: 'FIPS Codes',
    onImport: (data) => mapFipsCodes(data),
  },
  {
    order: 4,
    canOverwrite: true,
    canImport: true,
    component: <Transports />,
    icon: <SettingsInputComponent />,
    key: 'transportTypes',
    csvColumns: buildCsvColumns<TransportImport>([
      {
        name: 'name',
        type: 'string',
      },
      {
        name: 'ingressHD',
        note: 'Value must be 0-30',
        type: 'number',
      },
      {
        name: 'ingressSD',
        note: 'Value must be 0-30',
        type: 'number',
      },
      {
        name: 'wanHD',
        note: 'Value must be 0-30',
        type: 'number',
      },
      {
        name: 'wanSD',
        note: 'Value must be 0-30',
        type: 'number',
      },
    ]),
    name: 'Transports',
    onImport: (data) => mapTransports(data),
  },
  {
    order: 6,
    canOverwrite: false,
    canImport: false,
    component: <MediaFirst />,
    icon: <Settings />,
    name: 'MediaFirst Settings',
    show: args.values.mediaFirstSettings !== undefined,
  },
];

export const availableSettings = (
  args: CreateOperatorSettingProps
): CreateOperatorSetting[] => {
  return optionalSettings(args);
};
